import sortBy from 'lodash/sortBy';
import { useMemo } from 'react';

import { ComponentColumn } from 'approot/activity-builder/components/component.constants';
import { ColumnWrapper } from '../columns/columns.style';
import { ComponentViewWrapper } from 'approot/activity-builder/components/components-view-wrapper.style';
import ActivitySampleComponent from './activity-sample-components';
import { ComponentEventData } from 'approot/activity-builder/present/activity-builder-present-data-tracking.utils';
import type { InteractiveLessonSectionComponentFragment } from '../../lesson-builder.graphql.generated';
import {
  getAppliedColour,
  isBackgroundApplied,
  isBorderApplied,
} from 'approot/activity-builder/components/shared/component-settings-borders.utils';
import { getStyleProperties } from 'approot/activity-builder/components/components.utils';

type Props = {
  column: ComponentColumn;
  contentId: number;
  eventTrackingData?: ComponentEventData;
  openModal: (component: InteractiveLessonSectionComponentFragment) => void;
};

const ActivitySampleColumnsComponents = ({
  column,
  contentId,
  eventTrackingData,
  openModal,
}: Props) => {
  const sortedComponents = useMemo(
    () => sortBy(column.components, 'sort'),
    [column.components]
  );

  return (
    <ColumnWrapper>
      {sortedComponents.map(component => {
        return (
          <ComponentViewWrapper
            key={component.id}
            $colours={getAppliedColour(getStyleProperties(component))}
            $showBorder={isBorderApplied(getStyleProperties(component))}
            $showBackground={isBackgroundApplied(getStyleProperties(component))}
          >
            <ActivitySampleComponent
              component={component}
              contentId={contentId}
              eventTrackingData={eventTrackingData}
              openModal={openModal}
            />
          </ComponentViewWrapper>
        );
      })}
    </ColumnWrapper>
  );
};

export default ActivitySampleColumnsComponents;
